import { ClaimType } from 'all-in-one-shared-api';
import { Card, Typography } from 'antd';
import ClaimTypeIcon from 'components/claimTypeIcon';
import { StyledTitle } from 'components/StyledTitle';
import styled from 'styled-components';
const { Text } = Typography;

export interface PreviousClaimProps {
  claimType: ClaimType;
  title?: string;
  description?: string;
  doctor?: string;
  treatmentDate?: string;
  isSelected?: boolean;
}

export interface PreviousClaimCardProps extends PreviousClaimProps {
  index: number;
  handleOnClick: (index: number) => void;
}

const StyledCard = styled(Card)<Partial<PreviousClaimProps>>`
  ${(props) => props.isSelected && `border: var(--primary-color) 1px solid;`}
`;
const Wrapper = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: auto 1fr;
`;

const CardTextWrapper = styled.div`
  display: grid;
  column-gap: 4px;
`;
export const PreviousClaimCard = ({
  claimType,
  title,
  description,
  doctor,
  treatmentDate,
  index,
  handleOnClick,
  isSelected,
}: PreviousClaimCardProps) => (
  <StyledCard isSelected={isSelected}>
    <Wrapper onClick={() => handleOnClick(index)}>
      <ClaimTypeIcon claimType={claimType}></ClaimTypeIcon>
      <CardTextWrapper>
        <StyledTitle level={5}>{title}</StyledTitle>
        <Text>{description}</Text>
        <Text type="secondary">{doctor}</Text>
        <Text type="secondary">{treatmentDate}</Text>
      </CardTextWrapper>
    </Wrapper>
  </StyledCard>
);
